var map = {
	"./ClaimEvent": 23,
	"./ClaimEvent.tsx": 23,
	"./ClaimEventForm": 24,
	"./ClaimEventForm.tsx": 24,
	"./ClaimEventList": 22,
	"./ClaimEventList.tsx": 22,
	"./Footer": 40,
	"./Footer.tsx": 40,
	"./Header": 41,
	"./Header.tsx": 41,
	"./Welcome": 51,
	"./Welcome.tsx": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;